export function isFramed() {
  return window.top !== window;
}